module.exports = __webpack_public_path__ + "img/cooperate_20.a6fd3407.png";